var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10.0007C1.66699 6.85795 1.66699 5.28661 2.6433 4.3103C3.61961 3.33398 5.19096 3.33398 8.33366 3.33398H11.667C14.8097 3.33398 16.381 3.33398 17.3573 4.3103C18.3337 5.28661 18.3337 6.85795 18.3337 10.0007C18.3337 13.1433 18.3337 14.7147 17.3573 15.691C16.381 16.6673 14.8097 16.6673 11.667 16.6673H8.33366C5.19096 16.6673 3.61961 16.6673 2.6433 15.691C1.66699 14.7147 1.66699 13.1433 1.66699 10.0007Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99954 8.33398V11.6673M8.55586 9.16732L11.4426 10.834M11.4424 9.16732L8.55566 10.834",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6099 8.33398V11.6673M4.16621 9.16732L7.05296 10.834M7.05277 9.16732L4.16602 10.834",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.39 8.33398V11.6673M12.9463 9.16732L15.833 10.834M15.8328 9.16732L12.9461 10.834",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePassword);
export default __webpack_public_path__ + "static/media/UpdatePassword.7abc8a88c4a782c9f2467b0a26b14ec4.svg";
export { ForwardRef as ReactComponent };